import { API_ENDPOINTS } from './endpoints'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
console.log('API_URL:', API_URL) // Debug log to verify the API URL

interface EnterpriseData {
  email: string
  name: string
  site: string
  country: string
  ph: string
  // unit: string;
}

export async function createUser(userData) {
  try {
    const response = await axios.post(`${API_URL}${API_ENDPOINTS.CREATE_USER}`, userData)
    return response.data
  } catch (error) {
    console.error('Error adding farmer:', error)
    throw error
  }
}

export async function getAddOnEnquiry() {
  try {
    const token = localStorage.getItem('access_token') // Retrieve token

    if (!token) {
      throw new Error('No access token found. Please log in.')
    }
    const response = await axios.get(`${API_URL}${API_ENDPOINTS.GET_ADD_ON_ENQUIRY}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching enterprise:', error)
    throw error
  }
}

export async function updateAddOnEnquiry(updates) {
  const enquiryData = updates
  try {
    const response = await axios.put(
      `${API_URL}${API_ENDPOINTS.UPDATE_ADD_ON_ENQUIRY}`,
      enquiryData
    )
    return response.data
  } catch (error) {
    console.error('Error updating add-on enquiry:', error)
    throw error
  }
}

export const addEnterpriseData = async (data: EnterpriseData) => {
  try {
    const response = await axios.post(`${API_URL}${API_ENDPOINTS.ADD_ENTERPRISE}`, data, {
      headers: {
        Authorization: `Bearer ${process.env.API_KEY}`,
      },
    })

    return response.data
  } catch (error) {
    console.error('Error submitting enterprise data:', error)
    throw error
  }
}

export async function getEnterprises(params: { page?: number; limit?: number } = {}) {
  try {
    const query = new URLSearchParams()
    if (params.page) query.append('page', params.page.toString())
    if (params.limit) query.append('limit', params.limit.toString())
    const response = await axios.get(
      `${API_URL}${API_ENDPOINTS.GET_ENTERPRISES}?${query.toString()}`
    )
    return response.data
  } catch (error) {
    console.error('Error fetching enterprise:', error)
    throw error
  }
}

export async function getFarmers(params: {
  start_date?: string
  end_date?: string
  source?: string
  page?: number
  limit?: number
  sort_by?: string
  sort_order?: string
  search?: string
}) {
  try {
    // Construct query parameters
    const query = new URLSearchParams()

    if (params.start_date) query.append('start_date', params.start_date)
    if (params.end_date) query.append('end_date', params.end_date)
    if (params.source) query.append('source', params.source)
    if (params.page) query.append('page', params.page.toString())
    if (params.limit) query.append('limit', params.limit.toString())
    if (params.sort_by) query.append('sort_by', params.sort_by)
    if (params.sort_order) query.append('sort_order', params.sort_order)
    if (params.search) query.append('search', params.search)

    const response = await axios.get(`${API_URL}${API_ENDPOINTS.GET_FARMERS}?${query.toString()}`)
    return response.data
  } catch (error) {
    console.error('Error fetching Farmers:', error)
    throw error
  }
}

export async function getFarms(params: {
  start_date?: string
  end_date?: string
  page?: number
  limit?: number
  sort_by?: string
  sort_order?: string
  enterprise_id?: string
}) {
  try {
    // Construct query parameters
    const query = new URLSearchParams()

    // Set default date range (last 30 days) if not provided
    let startDate = params.start_date
    let endDate = params.end_date

    if (!startDate || !endDate) {
      const today = new Date()
      const thirtyDaysAgo = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000)
      startDate = startDate || thirtyDaysAgo.toISOString().split('T')[0]
      endDate = endDate || today.toISOString().split('T')[0]
    }

    query.append('start_date', startDate)
    query.append('end_date', endDate)

    if (params.page) query.append('page', params.page.toString())
    if (params.limit) query.append('limit', params.limit.toString())
    if (params.sort_by) query.append('sort_by', params.sort_by)
    if (params.sort_order) query.append('sort_order', params.sort_order)

    const response = await axios.get(`${API_URL}${API_ENDPOINTS.GET_FARMS}?${query.toString()}`)
    return response.data
  } catch (error) {
    console.error('Error fetching Farms:', error)
    throw error
  }
}

export async function getAllUser() {
  try {
    const response = await axios.get(`${API_URL}${API_ENDPOINTS.GET_All_USERS}`)
    return response.data
  } catch (error) {
    console.error('Error fetching users:', error)
    throw error
  }
}

export async function addFarmer(farmerData) {
  try {
    const response = await axios.post(`${API_URL}${API_ENDPOINTS.ADD_FARMERS}`, farmerData)
    return response.data
  } catch (error) {
    console.error('Error adding farmer:', error)
    throw error
  }
}

export async function getEnterpriseName() {
  try {
    const response = await axios.get(`${API_URL}${API_ENDPOINTS.GET_ENTERPRISE_NAME}`)
    return response.data
  } catch (error) {
    console.error('Error fetching users:', error)
    throw error
  }
}

export async function registerUser(userData) {
  try {
    const response = await axios.post(`${API_URL}${API_ENDPOINTS.REGISTER_USER}`, userData, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error registering user:', error)
    throw error
  }
}

export async function loginUser(data: { email: string; password: string }) {
  try {
    const response = await fetch(`${API_URL}${API_ENDPOINTS.LOGIN_USER}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: `username=${data.email}&password=${data.password}`,
    })
    const responseClone = response.clone()
    const jsonResponse = await responseClone.json()
    if (jsonResponse.user && jsonResponse.user.access_token) {
      localStorage.setItem('access_token', jsonResponse.user.access_token)
      console.log('Access Token Stored:', jsonResponse.user.access_token)
    }
    return response
  } catch (error) {
    console.error('Error during login API call:', error)
    throw error
  }
}

export async function sendOtp(payload: { email: string }) {
  try {
    const response = await axios.post(`${API_URL}${API_ENDPOINTS.SEND_OTP}`, {
      type: 'email',
      email: payload.email,
    })
    return response.data
  } catch (error) {
    console.error('Error sending OTP:', error)
    throw error
  }
}

export async function resetPassword(data) {
  try {
    const response = await axios.put(`${API_URL}${API_ENDPOINTS.RESET_PASSWORD}`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error resetting password:', error)
    throw error
  }
}

export async function updateFarmer(params: { farmer_id: number; is_active: boolean }) {
  try {
    const response = await axios.put(`${API_URL}${API_ENDPOINTS.UPDATE_FARMERS}`, params, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
  } catch (error) {
    console.error('Error updating farmer:', error)
    throw error
  }
}

export async function deactivateUser(userId: number, reason: string, entity: 'user' | 'enterprise' = 'user') {
  try {
    const response = await axios.patch(
      `${API_URL}${API_ENDPOINTS.DEACTIVATE_USER}/${userId}/Suspend`,
      {reason, entity},
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error deactivating user:', error)
    throw error
  }
}

export async function activateUser(userId: number, reason: string, entity: 'user' | 'enterprise' = 'user') {
  try {
    const response = await axios.patch(
      `${API_URL}${API_ENDPOINTS.ACTIVATE_USER}/${userId}/restore_user`,
      {reason, entity},
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error activating user:', error)
    throw error
  }
}

export async function updateEnterprise(params: {company_id: number; is_active: boolean}) {
  try {
    const response = await axios.put(`${API_URL}${API_ENDPOINTS.UPDATE_ENTERPRISE}`, params, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
  } catch (error) {
    console.error('Error updating enterprise:', error)
    throw error
  }
}

export async function getSubscriptions() {
  try {
    const response = await axios.get(`${API_URL}${API_ENDPOINTS.GET_SUBSCRIPTIONS}`)
    return response.data.subscriptions
  } catch (error) {
    throw error
  }
}

export async function updatePaidStatus(params: { farm_id: string; new_is_paid_status: boolean }) {
  try {
    const payload = {
      farm_id: params.farm_id,
      is_paid: params.new_is_paid_status,
    }
    const response = await axios.put(
      `${API_URL}${API_ENDPOINTS.UPDATE_SUBSCRIPTION_STATUS}`,
      payload,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    )
    return response
  } catch (error) {
    throw error
  }
}

export async function updateSubscriptionEndDate(params: { farm_id: string; end_date: string }) {
  try {
    const payload = {
      farm_id: params.farm_id,
      end_date: params.end_date,
    }
    const response = await axios.put(
      `${API_URL}${API_ENDPOINTS.UPDATE_SUBSCRIPTION_END_DATE}`,
      payload,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    )
    return response
  } catch (error) {
    throw error
  }
}

export async function getScheduleCall(params) {
  try {
    const queryParams = new URLSearchParams(params).toString()

    const response = await axios.get(
      `${API_URL}${API_ENDPOINTS.GET_SCHEDULE_CALL}?${queryParams}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data
  } catch (error) {
    console.error('Error fetching schedule call:', error)
    throw error
  }
}
export async function updateScheduleCallStatus(params: {
  schedule_call_id: number
  new_status: string
}) {
  try {
    const payload = {
      schedule_call_id: params.schedule_call_id,
      status: params.new_status,
    }

    const response = await axios.put(
      `${API_URL}${API_ENDPOINTS.UPDATE_SCHEDULE_CALL_STATUS}`,
      payload,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    )
    return response.data
  } catch (error) {
    throw error
  }
}

export async function getApiUsage(params: any) {
  console.log('params', params)
  try {
    const queryParams = new URLSearchParams()

    // Append company_id, start_date, and end_date as usual
    queryParams.append('company_id', params.company_id)
    queryParams.append('start_date', params.start_date)
    queryParams.append('end_date', params.end_date)

    // Append user_ids correctly as multiple query parameters
    params.user_ids.forEach((userId: string) => {
      queryParams.append('user_ids', userId)
    })

    // Append apis correctly as multiple query parameters
    params.apis.forEach((api: string) => {
      queryParams.append('apis', api)
    })

    const response = await axios.get(
      `${API_URL}${API_ENDPOINTS.GET_API_USAGE}?${queryParams.toString()}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    )

    return response
  } catch (error) {
    console.error('Error fetching API Usage call:', error)
    throw error
  }
}

export async function getApiLogs(params: any) {
  try {
    const queryParams = new URLSearchParams(params).toString()

    const response = await axios.get(`${API_URL}${API_ENDPOINTS.GET_API_LOGS}?${queryParams}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
    return response
  } catch (error) {
    console.error('Error fetching API Logs call:', error)
    throw error
  }
}

export const getUsersApiUsageDropdwon = async (companyId: number) => {
  try {
    const response = await axios.get(`${API_URL}${API_ENDPOINTS.GET_API_USERLIST}/${companyId}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
    return response // Return only the data to avoid unnecessary `.data` calls
  } catch (error) {
    console.error('Error fetching user list:', error)
    throw error
  }
}

export async function getAPIListDropDown() {
  try {
    const response = await axios.get(`${API_URL}${API_ENDPOINTS.GET_API_LIST}`)
    return response
  } catch (error) {
    console.error('Error fetching API List:', error)
    throw error
  }
}

export async function getTickets() {
  try {
    const response = await axios.get(`${API_URL}${API_ENDPOINTS.GET_TICKETS}`)
    return response.data
  } catch (error) {
    console.error('Error fetching tickets:', error)
    throw error
  }
}

export async function updateTicketSolution(ticketId: number, status: string, solution: string) {
  try {
    const url = `${API_URL}${API_ENDPOINTS.UPDATE_TICKETS}${ticketId}?status=${encodeURIComponent(
      status
    )}&solution=${encodeURIComponent(solution)}`
    const response = await axios.put(url)
    return response.data
  } catch (error) {
    console.error(`Error updating solution for ticket ${ticketId}:`, error)
    throw error
  }
}

export async function getLeads(params: {
  page?: number
  limit?: number
  sort_by?: string
  sort_order?: string
}) {
  try {
    // Construct query parameters
    const query = new URLSearchParams()
    if (params.page) query.append('page', params.page.toString())
    if (params.limit) query.append('limit', params.limit.toString())
    if (params.sort_by) query.append('sort_by', params.sort_by)
    if (params.sort_order) query.append('sort_order', params.sort_order)

    const response = await axios.get(`${API_URL}${API_ENDPOINTS.GET_LEADS}?${query.toString()}`)
    return response.data
  } catch (error) {
    console.error('Error fetching Leads:', error)
    throw error
  }
}

export async function createLeads(leadsData) {
  try {
    const response = await axios.post(`${API_URL}${API_ENDPOINTS.ADD_LEADS}`, leadsData)
    return response.data
  } catch (error) {
    console.error('Error adding leads:', error)
    throw error
  }
}

export async function deleteLead(leadId: number) {
  try {
    const response = await axios.delete(`${API_URL}${API_ENDPOINTS.DELETE_LEADS}/${leadId}`)

    if (response.data?.status_code === 200) {
      console.log('Lead deleted successfully:', response.data?.data)
      return response.data
    } else {
      throw new Error(response.data?.message || 'Failed to delete lead')
    }
  } catch (error) {
    console.error('Error deleting lead:', error)
    throw error
  }
}

export async function getLeadsCount() {
  try {
    const response = await axios.get(`${API_URL}${API_ENDPOINTS.GET_LEADS_COUNT}`)
    return response.data.data
  } catch (error) {
    console.error('Error fetching leads count:', error)
    throw error
  }
}

export async function updateLeads(params: {
  lead_id: number
  name?: string
  email?: string
  comment?: string
  phone?: string
  status?: string
  assignee_id?: number
}) {
  try {
    const payload = { ...params }

    const response = await axios.put(
      `${API_URL}${API_ENDPOINTS.UPDATE_LEADS}?lead_id=${params.lead_id}`,
      payload,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data
  } catch (error) {
    throw error
  }
}

export async function getAssignee() {
  try {
    const response = await axios.get(`${API_URL}${API_ENDPOINTS.GET_ASSIGNEES}`)
    return response.data.data.users
  } catch (error) {
    console.error('Error fetching assignees:', error)
    throw error
  }
}

export async function getContactList(params: { page?: number; limit?: number } = {}) {
  try {
    const query = new URLSearchParams()
    if (params.page) query.append('page', params.page.toString())
    if (params.limit) query.append('limit', params.limit.toString())
    const response = await axios.get(
      `${API_URL}${API_ENDPOINTS.GET_CONTACT_LIST}?${query.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error fetching contact list:', error)
    throw error
  }
}

export async function updateContactStatus(params: { contact_id: number; status: string }) {
  try {
    const response = await axios.put(
      `${API_URL}${API_ENDPOINTS.UPDATE_CONTACT_STATUS}${params.contact_id
      }?status=${encodeURIComponent(params.status)}`,
      {}, // Empty body since status is sent as a query param
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error updating contact status:', error)
  }
}

export async function getChartData() {
  try {
    const response = await axios.get(`${API_URL}${API_ENDPOINTS.GET_LEAD_CHART}`)
    if (!response?.data?.data) {
      console.error('Invalid response format')
      return { categories: [], series: [] }
    }

    const categories = Object.keys(response.data.data)
    const seriesNames = Object.keys(response.data.data[categories[0]] || {})

    const series = seriesNames.map((name) => {
      return {
        name,
        type: 'line',
        data: categories.map((date) => response.data.data[date][name] || 0),
      }
    })

    return { categories, series }
  } catch (error) {
    console.error('Error fetching chart data:', error)
    return { categories: [], series: [] }
  }
}

export async function getFeedback(params: { page?: number; limit?: number } = {}) {
  try {
    const query = new URLSearchParams()
    if (params.page) query.append('page', params.page.toString())
    if (params.limit) query.append('limit', params.limit.toString())

    const response = await axios.get(`${API_URL}${API_ENDPOINTS.GET_FEEDBACKS}?${query.toString()}`)

    // Extract the necessary data from the response
    if (response.data?.data?.data) {
      return {
        feedbacks: response.data.data.data, // The actual feedback list
        totalCount: response.data.data.total_count,
        totalPages: response.data.data.total_pages,
        currentPage: response.data.data.current_page,
        limit: response.data.data.limit,
      }
    } else {
      throw new Error('Invalid API response format')
    }
  } catch (error) {
    console.error('Error fetching feedback list:', error)
    throw error
  }
}


// Enterprise Contract Management APIs
// export async function renewContract(data: {
//   enterprise_id: number
//   new_contract_start_date: string
//   new_contract_duration_months: number
// }) {
//   try {
//     const token = localStorage.getItem('access_token')
//     const response = await axios.put(`${API_URL}${API_ENDPOINTS.RENEW_CONTRACT}`, data, {
//       headers: { Authorization: `Bearer ${token}` },
//     })
//     return response.data
//   } catch (error) {
//     console.error('Error renewing contract:', error)
//     throw error
//   }
// }

// export async function amendContract(data: {
//   enterprise_id: number
//   contract_start_date: string
//   contract_duration_months: number
// }) {
//   try {
//     const token = localStorage.getItem('access_token')
//     const response = await axios.put(`${API_URL}${API_ENDPOINTS.AMEND_CONTRACT}`, data, {
//       headers: { Authorization: `Bearer ${token}` },
//     })
//     return response.data
//   } catch (error) {
//     console.error('Error amending contract:', error)
//     throw error
//   }
// }